var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOwa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 21,
    viewBox: "0 0 77 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2728 20.5455C4.60833 20.5455 0 15.9386 0 10.2728C0 4.60833 4.60833 0 10.2728 0C15.9372 0 20.5455 4.60833 20.5455 10.2728C20.547 15.9386 15.9386 20.5455 10.2728 20.5455ZM10.2728 2.59317C6.03836 2.59317 2.59174 6.03835 2.59174 10.2742C2.59174 14.51 6.03693 17.9538 10.2728 17.9538C14.5086 17.9538 17.9538 14.5086 17.9538 10.2742C17.9538 6.03978 14.5086 2.59317 10.2728 2.59317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2021 0.636719H57.971L47.644 18.5049L37.3042 0.636719H34.0745L38.7242 8.69166L33.0583 18.5049L22.7413 0.636719H19.4902L30.6164 19.9092H35.4902L40.3455 11.5003L45.2007 19.9092H50.0745L61.2021 0.636719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6104 3.06862L65.0147 0.636719L66.4191 3.06862L74.7423 17.4773L76.1481 19.9092H73.3623L71.407 16.5225L71.3899 16.5325L65.0162 5.49908L58.6481 16.524L58.6453 16.5225L56.6901 19.9092H53.8828L55.2886 17.4773L63.6104 3.06862Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 21,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwa);
export default __webpack_public_path__ + "static/media/owa.b8dec579f83c9b7e43ac7b42689688ca.svg";
export { ForwardRef as ReactComponent };